module.exports = __webpack_public_path__ + "img/complete-icon.cb368433.svg";